import { useTimer } from '@hooks/client';
import { observer } from 'mobx-react-lite';
import React from 'react';

import { CardSellerInfoEntity, CardSellersWrapper } from '@/entities';
import {
  Description,
  Illustration,
  IllustrationModal,
  ModalContent,
  TagInfo,
} from '@/shared/ui';
import { useStore } from '@/store/context';

import styles from './invite-as-friend.module.scss';

export const InviteAsFriendFeature = observer(() => {
  const withdrawal = useStore()?.withdrawal;

  const {
    timer,
    count,
    // eslint-disable-next-line react-hooks/rules-of-hooks
  } = useTimer({
    duration: 300,
  });

  return (
    <>
      <ModalContent.Title
        title={'Friend Request'}
        subtitle={'Item Withdrawal'}
      />
      <IllustrationModal variant={'add-friend'} />

      <Description
        message={
          'To continue, add the seller as a friend on Roblox. After adding as a friend, click on “Ready!'
        }
      />

      <ModalContent.Footer>
        <ModalContent.Button
          variant={'primary'}
          text={'Add friend'}
          iconLeft={
            <Illustration
              name={'user-plus'}
              spriteName={'icons'}
              spanTagClassName={styles['icon']}
            />
          }
        />
        <ModalContent.Button
          variant={'secondary'}
          text={'Ready'}
          onClick={() => {
            withdrawal?.updateTradeStatus('verification');
          }}
        />
      </ModalContent.Footer>
    </>
  );
});
